import { createContext, Dispatch } from 'react';

export const EXPORT_REQUEST_KEY = 'export-request-key';

type ExportRequestContextValue = {
  exportRequestKey: string | null;
  setExportRequestKey: Dispatch<React.SetStateAction<string | null>>;
  isExportFailed: boolean;
  setIsExportFailed: Dispatch<React.SetStateAction<boolean>>;
  isConcurrencyError: boolean;
  setIsConcurrencyError: Dispatch<React.SetStateAction<boolean>>;
};

const contextDefaultValue: ExportRequestContextValue = {
  exportRequestKey: null,
  setExportRequestKey: () => null,
  isExportFailed: false,
  setIsExportFailed: () => null,
  isConcurrencyError: false,
  setIsConcurrencyError: () => null,
};

export const ExportRequestContext = createContext(contextDefaultValue);
